import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DevicesService } from 'src/app/_services/devices.service';

@Component({
  selector: 'app-add-product-to-shopping-cart',
  templateUrl: './add-product-to-shopping-cart.component.html',
  styleUrls: ['./add-product-to-shopping-cart.component.scss']
})
export class AddProductToShoppingCartComponent implements OnInit {

  diviceXs: boolean;
  diviceSm: boolean;

  totalByProduct = 0;

  constructor(private devicesService: DevicesService, public dialogRef: MatDialogRef<AddProductToShoppingCartComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router) { }



  ngOnInit(): void {
    this.totalByProduct = Number(this.data.product.price) * Number(this.data.product.quantity);

    this.devicesService.dievice$.subscribe(res => {
      console.log("device", res)
      this.diviceXs = res === 'xs' ? true : false;
      this.diviceSm = res === 'sm' ? true : false;
    });
  }

  CloseDialog(): void {
    this.dialogRef.close();
  }

  // goToShopingCart() {
  //   this.router.navigate([{ outlets: { primary: ['product', productId], sidebar: ['product', productId] } }]);
  // }

}
